var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo1151({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.512,
    height: 67.025,
    viewBox: "0 0 60.512 67.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#fff;}.b{fill:#f2bfe4;}.b,.c,.d,.e,.f,.h,.i,.j{fill-rule:evenodd;}.c{opacity:0.4;}.d{fill:#2437a8;}.e{fill:#0d0b6d;}.g{fill:none;stroke:#252535;}.h{fill:#ea7f47;}.i{fill:#393954;}.j{fill:#161629;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4079.395 -1317.798)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4079 1325.046)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(0.395 -0.223)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4086.758 1317.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.174,120.763l-.342-11.785s14.339,1.14,17.406-.451c0,0,3.748-19.29-.722-29.973l-.091-.416L52.167,74.6,50.285,91.734c-1.019-3-9.245-6.2-11.444-1.9-4.765,9.317,12.273,15.59,12.273,15.59L49.384,120.9",
    transform: "translate(-38 -61.662)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M93.428,158.057l-9.668-2.07,9.622,6.492Z",
    transform: "translate(-65.596 -110.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M127.2,112.687l3.341,8.158-4,.051Z",
    transform: "translate(-91.395 -84.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M112.512,116a2.024,2.024,0,1,1-2.352-1.629A2.021,2.021,0,0,1,112.512,116",
    transform: "translate(-80.513 -85.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M138.986,116a2.024,2.024,0,1,1-2.352-1.629A2.021,2.021,0,0,1,138.986,116",
    transform: "translate(-96.478 -85.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M117.744,139.187a4.729,4.729,0,0,0,4.171,2.074Z",
    transform: "translate(-86.09 -100.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M117.744,139.187a4.729,4.729,0,0,0,4.171,2.074",
    transform: "translate(-86.09 -100.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M59.974,99.8a13.806,13.806,0,0,0-6.21-3.743l.285-5.9,14.214-2.475A15.951,15.951,0,0,1,59.974,99.8Z",
    transform: "translate(-47.507 -69.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M92.923,61.2C91.642,59.98,83.3,59.6,73.263,60.374c-2.334.179-4.571.406-6.64.668-6.839.858-11.871,2.078-12.69,3.151-.909-13.409,7.314-21.395,18.08-22.138,7.063-.488,13.468,2.265,17.3,8A23.115,23.115,0,0,1,92.923,61.2",
    transform: "translate(-47.568 -42)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.056 7.762)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M112.468,73.255h0a.464.464,0,0,0-.158-.266c-1.281-1.217-9.627-1.594-19.66-.822-2.334.179-4.571.406-6.639.668,2.943-2.792,8.326-7.207,14.676-9.188a48.551,48.551,0,0,1,8.016-1.8c6.182-.818,11.141.022,11.389,3.227.32,4.171-6.553,7.663-7.62,8.18",
    transform: "translate(-86.008 -61.556)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo1151);
export default __webpack_public_path__ + "static/media/Grupo 1151.5f131e0ec958b7432bd810eca0569940.svg";
export { ForwardRef as ReactComponent };